module.exports = __webpack_public_path__ + "img/rzsb-png.7573aa31.png";